import { Resident } from 'src/store/sageAdminApi';

export enum RoutineCheckDurationsInMin {
    WARNING_THRESHOLD = 25,
}

export type ResidentWithTimeSinceLastCare = Resident & { timeSinceLastCareActivityInMin: number };
